import {
    GET_KNOWLEDGECENTER_DOC,
    GET_KNOWLEDGECENTER_DOC_SUCCESS,
    GET_KNOWLEDGECENTER_DOC_FAIL,
    UPLOAD_KNOWLEDGECENTER_DOC,
    UPLOAD_KNOWLEDGECENTER_DOC_FAIL,
    UPLOAD_KNOWLEDGECENTER_DOC_SUCCESS,
    RM_KNOWLEDGECENTER_DOC,
    RM_KNOWLEDGECENTER_DOC_SUCCESS,
    RM_KNOWLEDGECENTER_DOC_FAIL
} from "./constant"

export const uploadKnowledgeCenterDoc = (payload) => {
    return {
        type: UPLOAD_KNOWLEDGECENTER_DOC,
        payload
    }
}

export const uploadKnowledgeCenterDocSuccess = (payload) => {
    return {
        type: UPLOAD_KNOWLEDGECENTER_DOC_SUCCESS,
        payload
    }
}

export const uploadKnowledgeCenterDocFail = (payload) => {
    return {
        type: UPLOAD_KNOWLEDGECENTER_DOC_FAIL,
        payload
    }
}



export const getKnowledgeCenterDoc = () => {
    return {
        type: GET_KNOWLEDGECENTER_DOC
    }
}

export const getKnowledgeCenterDocSuccess = (payload) => {
    return {
        type: GET_KNOWLEDGECENTER_DOC_SUCCESS,
        payload
    }
}

export const getKnowledgeCenterDocFail = (payload) => {
    return {
        type: GET_KNOWLEDGECENTER_DOC_FAIL,
        payload
    }
}


// To remove knowledge center file
export const rmKnowledgeCenterFile = (payload) =>{
    return{
        type: RM_KNOWLEDGECENTER_DOC,
        payload
    }
}

export const rmKnowledgeCenterFileSuccess = (payload) =>{
    return{
        type: RM_KNOWLEDGECENTER_DOC_SUCCESS,
        payload
    }
}

export const rmKnowledgeCenterFileFail =(payload)=>{
    return{
        type: RM_KNOWLEDGECENTER_DOC_FAIL,
        payload
    }
}